import { useRoute } from '@react-navigation/native';
import { useMemo } from 'react';
import useCallbackWithCtx from 'src/hooks/useCallbackUtils/useCallbackWithCtx';
import { useDeleteQPMutation } from '../../graphql/qp/delete';
import { useQPAuthorQuery } from '../../graphql/qp/getAuthor';
import { useQPDetailsQuery } from '../../graphql/qp/getDetails';
import { useQPPlaylist } from '../../graphql/question/getQuestionPlaylistForQP';
import { useQuestionListForQPQuery } from '../../graphql/question/getQuestionsForQP';
import buildEPQuestionNavParams from '../../navigation/buildEPQuestionNavParams';
import { pageAnalytics } from './analytics';
export default function useData() {
    const route = useRoute();
    const { examLevel, subject, qp, qpID } = route.params;
    const [listQueryState, listQueryActions] = useQuestionListForQPQuery();
    const listQueryVar = useMemo(() => ({ questionPaperID: qpID }), [qpID]);
    const buildQuestionNavParams = useCallbackWithCtx((ctx, question, index) => buildEPQuestionNavParams({
        examLevel: ctx.examLevel,
        subject: ctx.subject,
        question,
        qp: ctx.qp,
        questionID: question.id,
        navigatedFrom: 'QP_QUESTIONS',
        navigationData: {
            qpID: ctx.qpID,
            sequence: index,
        },
    }), { examLevel, subject, qp, qpID });
    const trackQuestionPress = useCallbackWithCtx(() => {
        pageAnalytics.setWidget('QuestionList').setTarget('Question').click();
    }, []);
    const getQuestionDetailsTo = useCallbackWithCtx((ctx, question, index) => ({
        screen: 'EP_Question',
        params: ctx.buildQuestionNavParams(question, index),
    }), { buildQuestionNavParams });
    const [playlistState, playlistActions] = useQPPlaylist(qpID);
    const [qpDetailsQueryState, qpDetailsQueryActions] = useQPDetailsQuery(qpID, {
        lazy: true,
    });
    const [qpAuthorQueryState] = useQPAuthorQuery(qpID);
    const [deleteQPMutationState, deleteQPMutationActions] = useDeleteQPMutation();
    const state = {
        listQuery: listQueryState,
        listQueryVar,
        qpDetailsQuery: qpDetailsQueryState,
        playlist: playlistState,
        qpAuthorQuery: qpAuthorQueryState,
        deleteQPMutation: deleteQPMutationState,
    };
    const actions = {
        listQuery: listQueryActions,
        qpDetailsQuery: qpDetailsQueryActions,
        playlist: playlistActions,
        trackQuestionPress,
        getQuestionDetailsTo,
        deleteQPMutation: deleteQPMutationActions,
    };
    return [state, actions];
}
